/**
 * Card — content card with optional press feedback.
 * Atom purity: imports only react + tokens.
 */
import { CSSProperties, ReactNode, useState } from 'react';
import { P } from '../../styles/tokens';

export interface CardProps {
  children: ReactNode;
  p?: number;
  bg?: string;
  r?: number;
  onClick?: () => void;
  hover?: boolean;
  style?: CSSProperties;
}

export function Card({
  children,
  p = 16,
  bg = P.card,
  r = 16,
  onClick,
  hover = false,
  style,
}: CardProps) {
  const [pressed, setPressed] = useState(false);

  const interactive = !!onClick;
  const lifted = interactive && hover && pressed;

  const base: CSSProperties = {
    background: bg,
    borderRadius: r,
    padding: p,
    boxSizing: 'border-box',
    border: `1px solid ${P.line}`,
    cursor: interactive ? 'pointer' : 'default',
    transform: lifted ? 'translateY(-1px) scale(0.99)' : 'none',
    transition: 'transform 0.15s ease, box-shadow 0.15s ease',
    boxShadow: lifted
      ? '0 8px 18px rgba(45,37,24,0.08)'
      : '0 1px 3px rgba(45,37,24,0.04)',
    ...style,
  };

  return (
    <div
      onClick={onClick}
      onPointerDown={interactive ? () => setPressed(true) : undefined}
      onPointerUp={interactive ? () => setPressed(false) : undefined}
      onPointerLeave={interactive ? () => setPressed(false) : undefined}
      style={base}
    >
      {children}
    </div>
  );
}
